import applicationPlatform from '../platform';

interface LocalStore {
  local: { [key: string]: any };
}
interface CommonStorageInterface {
  setItem(key: string, value: any): void;
  getItem(key: string): any;
  removeItem(key: string): void;
}
export const CommonStorage = (() => {
  let instance: CommonStorageInterface;
  const defaultStorage: CommonStorageInterface & LocalStore = {
    local: {},
    setItem: function(key: string, value: any): any {
      this.local[key] = value;
    },
    getItem: function(key: string): any {
      return this.local[key];
    },
    removeItem: function(key: string): void {
      delete this.local[key];
    }
  };

  function createInstance(): CommonStorageInterface {
    const vault: CommonStorageInterface | Storage =
      typeof Storage === 'undefined' ||
      !applicationPlatform.sessionStorageAvailable
        ? defaultStorage
        : sessionStorage;
    return {
      setItem: function(key: string, value: any): void {
        vault.setItem(key, JSON.stringify(value));
      },
      getItem: function(key: string): any | undefined {
        const value = vault.getItem(key);
        if (value) {
          return JSON.parse(value);
        }
      },

      removeItem: function(key: string) {
        vault.removeItem(key);
      }
    };
  }

  return {
    getInstance: function() {
      if (!instance) {
        instance = createInstance();
      }
      return instance;
    }
  };
})();
